import {
  GetCampaignQuery,
  ListPersonalizedGifsQuery,
  MessagingStrategyName,
} from "~frontend/__generated__/graphql";

export type PersonalizedGif =
  ListPersonalizedGifsQuery["listPersonalizedGifs"][number];

export type CampaignPersonalizedGif = NonNullable<
  GetCampaignQuery["getCampaignByShortId"]["scriptVariants"][number]["personalizedGif"]
>;

export const VALID_PERSONALIZED_GIF_MESSAGING_STRATEGIES = [
  MessagingStrategyName.BandwidthShortCode,
  MessagingStrategyName.BandwidthTollFree,
  MessagingStrategyName.Bandwidth_10Dlc,
  MessagingStrategyName.Bandwidth_10DlcPool,
  MessagingStrategyName.Fake,
  MessagingStrategyName.FakePool,
  MessagingStrategyName.FakeShortCode,
  MessagingStrategyName.FakeTollFree,
];
